export default function Ornament({ style }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 14, color: "var(--ink-4)", ...style }}>
      <div style={{ flex: 1, height: 1, background: "var(--line)" }} />
      <svg width="18" height="8" viewBox="0 0 18 8" fill="none" stroke="currentColor" strokeWidth="1">
        <path d="M1 4h5M12 4h5" strokeLinecap="round"/>
        <path d="M9 1v6M7 4h4" strokeLinecap="round"/>
      </svg>
      <div style={{ flex: 1, height: 1, background: "var(--line)" }} />
    </div>
  );
}
